import Route from 'mewe/routes/route';
import { Theme } from 'mewe/constants';

export default Route.extend({
  theme: Theme.EVENT,

  beforeModel() {
    const eventId = this.paramsFor('app.event').event_id;

    this.dispatch('events', 'loadAttendees', 'attending', false, eventId);
    this.dispatch('events', 'getAttendeesCount', eventId);
  },

  model() {
    return this.modelFor('app.event');
  },
});
